import {createThunk} from '~ui/store/utils';
import toaster from '~ui/utils/toaster';
import {i18n} from '~ui/components/AsideNavigation/i18n';
import {getPageByIdWithDetails} from '~ui/store/thunks/pages';

interface RecoveryTokenDeleteThunkArgs {
    recoveryTokenId: number;
}

export const recoveryTokenDelete = createThunk(
    'delete-perm-page',
    ({recoveryTokenId}: RecoveryTokenDeleteThunkArgs, thunkAPI) => {
        const {sdk} = thunkAPI.extra;
        return sdk.wiki.recoveryTokenDelete({recoveryTokenId}).then(() => {
            toaster.createToast({
                type: 'success',
                title: i18n('page-deleted'),
                name: 'deleting-page',
            });
        });
    },
);

interface RecoverPageByTokenThunkArgs {
    recoveryTokenId: number;
}

export const recoverPageByToken = createThunk(
    'recover-page',
    async ({recoveryTokenId}: RecoverPageByTokenThunkArgs, {extra: {sdk}, dispatch}) => {
        return sdk.wiki.recoverPageByToken({recoveryTokenId}).then((item) => {
            dispatch(getPageByIdWithDetails({id: Object(item).id}));
            return item;
        });
    },
);
